import React, { Fragment, useState, useContext } from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import { withStyles } from '@material-ui/core/styles'
import {
  Button,
  Dialog,
  Grid,
  Snackbar,
  Slide,
  Backdrop,
  CircularProgress,
} from '@material-ui/core'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Cancel, AccessTime } from '@material-ui/icons'
import axios from 'axios'
import Moment from 'moment'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

export default function EnableStartAgainTechnical(props) {
  const classes = useStyles()

  const [disabled, setDisabled] = useState(false)
  const [loader, setLoader] = useState(true)
  const [returnLogin, setReturnLogin] = React.useState(false)
  const [error, setError] = useState('')
  const [openAlert, setOpenAlert] = useState(false)
  const [mensaje, setMensaje] = useState('')

  let keyAuthorization = localStorage.getItem('Session')
  let user = localStorage.getItem('user')
  let userId = localStorage.getItem('id')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  const handleCloseDialog = (pro) => (event) => {
    props.exit()
  }

  const idData = props.id.id

  const submitForm = (e) => {
    e.preventDefault()
    setLoader(true)
    const dataValues = {
      startAgain: JSON.stringify({
        userId: userId,
        user: user,
        date: Moment().format('YYYY-MM-DD'),
      }),
      status: 1
    }

    axios
      .put(`${urlServices}tests-users/${idData}`, dataValues, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then((response) => {
        props.callBackRefresh()
        setMensaje('Prueba activada con éxito')
        setOpenAlert(true)
        setError('success')
        setDisabled(true)
        setLoader(false)
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          console.log(e)
        }
      })
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenAlert(false)
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container className={classes.containerProfile}>
              <Grid item xs={12} md={12} style={{ margin: '20px 0' }}>
                <center>
                  <div className={classes.titleCardFilter}>
                    ¿Desea activar nuevamente la prueba?
                  </div>
                </center>
              </Grid>
              <Grid item xs={12} md={12} style={{ margin: '25px 0' }}>
                <center>
                  <Button
                    className={classes.buttonSubmit2}
                    onClick={submitForm}
                    startIcon={<AccessTime />}
                    disabled={disabled}
                  >
                    Activar
                  </Button>
                </center>
              </Grid>
            </Grid>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity={error}
            elevation={6}
            variant="filled"
          >
            {mensaje}
          </Alert>
        </Slide>
      </Snackbar>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  )
}
